Object.assign(window.FazendaRP.Pages.financeiro, {

    // Carrega contas do Supabase
    loadContasData: async function () {
        const { data, error } = await window.FazendaRP.supabase
            .from('financeiro_contas').select('*').order('nome');
        if (error) {
            console.error(error);
            return [];
        }
        this.contasData = data || [];
        return this.contasData;
    },

    renderContas: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Carregando contas...</div>';

        await this.loadContasData();

        container.innerHTML = `
            <div class="data-table-container">
                 <div class="action-bar" style="justify-content: flex-end;">
                    <button id="btn-nova-conta-banco" class="btn btn-primary">+ Nova Conta/Cartão</button>
                </div>
                
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Nome da Conta / Cartão</th>
                            <th>Tipo</th>
                            <th>Banco / Instituição</th>
                            <th>Saldo Inicial</th>
                            <th width="100">Ações</th>
                        </tr>
                    </thead>
                    <tbody id="lista-contas-banco">
                        <!-- JS Generated -->
                    </tbody>
                </table>
            </div>

            <!-- Modal Nova Conta -->
            <div id="modal-conta-banco" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; align-items: center; justify-content: center;">
                <div style="background: white; width: 450px; padding: 25px; border-radius: 8px; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
                     <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                        <h3 style="margin: 0;">Nova Conta / Cartão</h3>
                        <button type="button" class="btn-close-modal-banco" style="background: none; border: none; font-size: 1.5rem; cursor: pointer;">&times;</button>
                    </div>
                    <form id="form-conta-banco">
                        <div class="form-group">
                            <label>Nome identificador *</label>
                            <input type="text" id="cb-nome" placeholder="Ex: BB Principal, Cartão Black" required style="width: 100%;">
                        </div>
                        <div class="form-group" style="margin-bottom: 20px;">
                            <label>Tipo</label>
                            <select id="cb-tipo" style="width: 100%;">
                                <option>Conta Corrente</option>
                                <option>Conta Poupança</option>
                                <option>Cartão de Crédito</option>
                                <option>Caixa Físico</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Instituição / Banco</label>
                            <input type="text" id="cb-inst" placeholder="Ex: Banco do Brasil" style="width: 100%;">
                        </div>

                        <!-- CAMPOS ESPECÍFICOS DE CARTÃO -->
                        <div id="campos-cartao" style="display:none; background: #f9fafb; padding: 15px; border-radius: 6px; border: 1px solid #eee; margin-bottom: 20px;">
                            <h4 style="margin: 0 0 10px 0; font-size: 0.9rem; color: #4b5563;">Configuração da Fatura</h4>
                            <div style="display: flex; gap: 15px;">
                                <div style="flex: 1;">
                                    <label style="font-size: 0.85rem;">Dia Fechamento *</label>
                                    <input type="number" id="cb-fechamento" min="1" max="31" placeholder="Ex: 25" style="width: 100%;">
                                    <small style="color:#9ca3af; font-size: 0.75rem;">Melhor dia compra</small>
                                </div>
                                <div style="flex: 1;">
                                    <label style="font-size: 0.85rem;">Dia Vencimento *</label>
                                    <input type="number" id="cb-vencimento" min="1" max="31" placeholder="Ex: 05" style="width: 100%;">
                                </div>
                            </div>
                            <div style="margin-top: 10px;">
                                <label style="font-size: 0.85rem;">Limite de Crédito (R$)</label>
                                <input type="text" id="cb-limite" class="currency-mask" placeholder="R$ 0,00" style="width: 100%;">
                            </div>
                        </div>

                        <div class="form-group" id="grupo-saldo-inicial">
                            <label>Saldo Inicial (R$)</label>
                            <input type="text" id="cb-saldo" placeholder="R$ 0,00" style="width: 100%;">
                        </div>
                        <div style="text-align: right; margin-top: 20px;">
                            <button type="button" class="btn btn-close-modal-banco" style="background: #e5e7eb; margin-right: 10px;">Cancelar</button>
                            <button type="submit" class="btn btn-success">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        `;

        const renderRows = () => {
            const tbody = container.querySelector('#lista-contas-banco');
            if (this.contasData.length === 0) {
                tbody.innerHTML = '<tr><td colspan="5" style="text-align:center; padding:15px;">Nenhuma conta cadastrada.</td></tr>';
                return;
            }
            tbody.innerHTML = this.contasData.map(c => `
                <tr>
                    <td>${c.nome}</td>
                    <td>${c.tipo}</td>
                    <td>${c.instituicao || '-'}</td>
                    <td>${(c.tipo === 'Cartão de Crédito') ? '-' : 'R$ ' + (c.saldo_inicial || 0).toFixed(2).replace('.', ',')}</td>
                    <td>
                        <button class="btn-edit-conta" data-id="${c.id}" style="border:none; background:none; color:var(--color-primary); cursor:pointer; margin-right: 10px;"><i class="fas fa-edit"></i></button>
                        <button class="btn-del-conta" data-id="${c.id}" style="border:none; background:none; color:red; cursor:pointer;"><i class="fas fa-trash"></i></button>
                    </td>
                </tr>
            `).join('');

            tbody.querySelectorAll('.btn-edit-conta').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const id = parseInt(e.target.closest('button').dataset.id);
                    const conta = this.contasData.find(c => c.id === id);
                    if (conta) {
                        const form = container.querySelector('#form-conta-banco');
                        const modal = container.querySelector('#modal-conta-banco');
                        form.querySelector('#cb-nome').value = conta.nome;
                        form.querySelector('#cb-tipo').value = conta.tipo;
                        form.querySelector('#cb-inst').value = conta.instituicao || '';

                        // Cartão
                        form.querySelector('#cb-fechamento').value = conta.dia_fechamento || '';
                        form.querySelector('#cb-vencimento').value = conta.dia_vencimento || '';

                        // Moedas
                        const fmtMoney = (v) => "R$ " + (v || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        form.querySelector('#cb-saldo').value = fmtMoney(conta.saldo_inicial);
                        form.querySelector('#cb-limite').value = fmtMoney(conta.limite_credito);

                        form.dataset.id = id;
                        modal.querySelector('h3').innerText = "Editar Conta / Cartão";
                        if (typeof toggleSaldoVisibility === 'function') toggleSaldoVisibility();
                        modal.style.display = 'flex';
                    }
                });
            });

            tbody.querySelectorAll('.btn-del-conta').forEach(btn => {
                btn.addEventListener('click', async (e) => {
                    const id = parseInt(e.target.closest('button').dataset.id);
                    if (confirm('Excluir esta conta?')) {
                        const { error } = await window.FazendaRP.supabase.from('financeiro_contas').delete().eq('id', id);
                        if (error) {
                            window.FazendaRP.Toast.show('error', 'Erro', 'Não foi possível excluir.');
                        } else {
                            window.FazendaRP.Toast.show('success', 'Sucesso', 'Conta excluída.');
                            await this.loadContasData();
                            renderRows();
                        }
                    }
                });
            });
        };
        renderRows();

        const modal = container.querySelector('#modal-conta-banco');
        const form = container.querySelector('#form-conta-banco');
        container.querySelector('#btn-nova-conta-banco').addEventListener('click', () => {
            modal.style.display = 'flex';
            form.reset();
            delete form.dataset.id;
            modal.querySelector('h3').innerText = "Nova Conta / Cartão";
            toggleSaldoVisibility();
        });
        container.querySelectorAll('.btn-close-modal-banco').forEach(b => b.addEventListener('click', () => modal.style.display = 'none'));

        // Lógica de Visibilidade Saldo (Cartão não tem saldo inicial, tem configuração)
        const toggleSaldoVisibility = () => {
            const sel = container.querySelector('#cb-tipo');
            const grpSaldo = container.querySelector('#grupo-saldo-inicial');
            const grpCartao = container.querySelector('#campos-cartao');

            if (sel) {
                const isCartao = sel.value === 'Cartão de Crédito';
                if (grpSaldo) grpSaldo.style.display = isCartao ? 'none' : 'block';
                if (grpCartao) grpCartao.style.display = isCartao ? 'block' : 'none';
            }
        };
        const selTipo = container.querySelector('#cb-tipo');
        if (selTipo) selTipo.addEventListener('change', toggleSaldoVisibility);

        // Máscara de Moeda (Generic)
        const applyMoneyMask = (e) => {
            let value = e.target.value.replace(/\D/g, "");
            value = (Number(value) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
            e.target.value = value;
        };
        const inputSaldo = form.querySelector('#cb-saldo');
        if (inputSaldo) inputSaldo.addEventListener('input', applyMoneyMask);

        const inputLimite = form.querySelector('#cb-limite');
        if (inputLimite) inputLimite.addEventListener('input', applyMoneyMask);

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const parseMoney = (str) => parseFloat((str || '0').replace(/[^0-9,.-]+/g, "").replace(/\./g, '').replace(',', '.')) || 0;

            const payload = {
                nome: container.querySelector('#cb-nome').value,
                tipo: container.querySelector('#cb-tipo').value,
                instituicao: container.querySelector('#cb-inst').value,
                saldo_inicial: parseMoney(container.querySelector('#cb-saldo').value),
                // Campos Cartão
                dia_fechamento: parseInt(container.querySelector('#cb-fechamento').value) || null,
                dia_vencimento: parseInt(container.querySelector('#cb-vencimento').value) || null,
                limite_credito: parseMoney(container.querySelector('#cb-limite').value)
            };

            const btnSub = form.querySelector('button[type="submit"]');
            btnSub.disabled = true; btnSub.innerText = "Salvando...";

            let error;
            if (form.dataset.id) {
                const { error: err } = await window.FazendaRP.supabase.from('financeiro_contas').update(payload).eq('id', form.dataset.id);
                error = err;
            } else {
                const { error: err } = await window.FazendaRP.supabase.from('financeiro_contas').insert([payload]);
                error = err;
            }

            if (error) {
                window.FazendaRP.Toast.show('error', 'Erro', 'Erro ao salvar conta.');
                console.error(error);
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Conta salva!');
                await this.loadContasData();
                renderRows();
                modal.style.display = 'none';
            }
            btnSub.disabled = false; btnSub.innerText = "Salvar";
        });
    }

});
